import { Check, Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "../../state/theme";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";

const OPTIONS = [
  { value: "light", label: "Light", Icon: Sun },
  { value: "dark", label: "Dark", Icon: Moon },
  { value: "system", label: "Auto", Icon: Monitor, hint: "Match device" },
];

// Theme menu in the black top-utility bar: Light / Dark / Auto (follows device).
export default function ThemeToggle({ compact = false }) {
  const { mode, isDark, setTheme } = useTheme();
  const current = OPTIONS.find((o) => o.value === mode) || OPTIONS[2];
  const TriggerIcon = mode === "system" ? Monitor : isDark ? Moon : Sun;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          aria-label={`Theme: ${current.label}. Change theme`}
          data-testid="theme-toggle"
          data-theme-state={isDark ? "dark" : "light"}
          data-theme-mode={mode}
          className="inline-flex items-center gap-1.5 border border-white/25 hover:border-[#F59E0B] hover:text-[#F59E0B] text-white font-mono text-[10px] tracking-[0.14em] uppercase px-2 py-0.5 min-h-[22px] leading-none transition-colors outline-none focus-visible:border-[#F59E0B]"
        >
          <TriggerIcon className="h-3 w-3" strokeWidth={2} />
          {!compact && <span className="hidden sm:inline">{current.label}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        sideOffset={6}
        data-testid="theme-menu"
        className="min-w-[168px] rounded-none border border-white/15 bg-[#0A0A0A] p-1 text-white shadow-xl"
      >
        {OPTIONS.map(({ value, label, Icon, hint }) => (
          <DropdownMenuItem
            key={value}
            onSelect={() => setTheme(value)}
            data-testid={`theme-option-${value}`}
            className="flex cursor-pointer items-center gap-2.5 rounded-none px-2.5 py-2 font-mono text-[11px] uppercase tracking-[0.14em] text-white/80 focus:bg-white/10 focus:text-[#FF9F1C]"
          >
            <Icon className="h-3.5 w-3.5" strokeWidth={2} />
            <span className="flex-1">
              {label}
              {hint && <span className="ml-2 normal-case tracking-normal text-white/40">{hint}</span>}
            </span>
            {mode === value && <Check className="h-3.5 w-3.5 text-[#FF9F1C]" strokeWidth={2.5} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
